import { HubConnectionBuilder, LogLevel } from '@aspnet/signalr';
import EventAggregator from './EventAggregator';
import { concatSlash } from './Utils';
import Log from '../../utils/log';
import { notifyConnectionError, setConnectionErrorCallback } from './connectionError';

const Aggregator = new EventAggregator();

let connection = null;

export const disconnettiSignalR = () => {
  if (connection) connection.stop();
};

let tentativi = 0;

const avviaConnessione = (con) => {
  if (tentativi > 20) {
    // eslint-disable-next-line max-len
    notifyConnectionError('Non è stato possibile creare una connessione permanente con il server. Verificare di non avere antivirus che blocchino le connessioni o problemi con la rete.');
    tentativi = 0;
  }

  // / random delay prima della connessione per evitare riconnessioni in massa
  const delay = Math.floor(Math.random() * 2 * tentativi);

  setTimeout(() => {
    con
      .start()
      .catch((err) => Log.error(err.toString()));
  }, delay * 1000);

  tentativi += 1;
};

/**
 * Avvia connessione.
 * @param {string=} idUtente Identificativo utente passato poi all'Hub in query string
 * @param {string=} url Url per la connessione ad un Hub SignalR
 * @param {string=} accessToken AccessToken utilizzato per l'autenticazione con il server.
 * Se specificato il livello di log viene alzato da Information a Warning.
 * Vedere https://docs.microsoft.com/it-it/aspnet/core/signalr/security?view=aspnetcore-2.1#access-token-logging
 * @param {string=} gruppi eventuale parametro per specificare il gruppo di appartenenza.
 */
export const connettiSignalR = (idUtente = undefined, url = undefined, accessToken = undefined, gruppi = undefined) => {
  let pathName = window.location.pathname;
  pathName = pathName.length > 1 ? pathName : '';
  let connUrl = concatSlash(url || pathName);
  connUrl = `${connUrl}notifications${gruppi ? `?gruppi=${gruppi}` : ''}`;
  if (accessToken) {
    connection = new HubConnectionBuilder()
      .withUrl(connUrl, { accessTokenFactory: () => accessToken })
      .configureLogging(LogLevel.Warning)
      .build();
  } else {
    connection = new HubConnectionBuilder()
      .withUrl(connUrl)
      .configureLogging(LogLevel.Information)
      .build();
  }
  if (idUtente) {
    connection.qs = { UserId: idUtente };
  }
  connection.on('Notify', (evt, data) => {
    Aggregator.pubblica(evt, data);
  });
  connection.onclose(() => avviaConnessione(connection));
  avviaConnessione(connection);
};

Aggregator.connettiSignalR = connettiSignalR;
Aggregator.disconnettiSignalR = disconnettiSignalR;
Aggregator.setConnectionErrorCallback = setConnectionErrorCallback;

export default Aggregator;
